import moment from "moment";

const fakeAppointmentsService = {
    dateFormat: "DD.MM.YYYY",
    timeFormat: " HH:mm",
    getAppointments: async function () {
        return Promise.resolve([
            {
                title: "Jünemann's Ovend",
                date: moment("25.01.2025 17:30", this.dateFormat + this.timeFormat),
                canceled: false
            },
            {
                title: "Stonn op un Danz! im Scala Club Opladen",
                date: moment("06.11.2026 18:30", this.dateFormat + this.timeFormat),
                canceled: false
            },
            {
                title: "Rosenmontag im Funkenkeller, Eintritt frei",
                date: moment("16.02.2026 14:00", this.dateFormat + this.timeFormat),
                canceled: false
            },
            {
                title: "Sommerfest auf dem Gelände St Elisabeth Kirche in Opladen, Eintritt frei",
                date: moment("13.06.2026 14:00", this.dateFormat + this.timeFormat),
                canceled: false
            },
            {
                title: "Oktoberfest im Funkenkeller",
                date: moment("2.10.2023", this.dateFormat),
                canceled: false
            },
            {
                title: "Sessionseröffnung im Funkenkeller, Eintritt frei",
                date: moment("11.11.2026 18:00", this.dateFormat + this.timeFormat),
                canceled: false
            },
            {
                title: "Mitsing Abend Im Stilbruch Opladen, Eintritt frei",
                date: moment("21.11.2025 19:00", this.dateFormat + this.timeFormat),
                canceled: false
            },
            {
                title: "Feldmesse in der St. Elisabeth Kirche",
                date: moment("24.01.2026 18:30", this.dateFormat + this.timeFormat),
                canceled: false
            },
            {
                title: "Kindersitzung im Scala Club Opladen, Eintritt: 9 Euro (Kinder), 12 Euro (Erwachsene)",
                date: moment("18.01.2026 13:00", this.dateFormat + this.timeFormat),
                canceled: false
            },
            {
                title: "Abend unter Freunden in der Stadthalle Bergisch Neukirchen",
                date: moment("27.01.2024", this.dateFormat),
                canceled: false
            },
            {
                title: "Herrensitzung im Festzelt am Marktplatz Opladen, Eintritt: 40 Euro",
                date: moment("08.02.2026 13:30", this.dateFormat + this.timeFormat),
                canceled: false
            },
            {
                title: "Weiberfastnacht im Funkenkeller",
                date: moment("12.02.2026 17:00", this.dateFormat + this.timeFormat),
                canceled: false
            },
            {
                title: "After Zoch Party im Funkenkeller, Eintritt frei",
                date: moment("12.02.2026 17:00", this.dateFormat + this.timeFormat),
                canceled: false
            },
            {
                title: "Kellergaudi im Funkenkeller, Eintritt frei",
                date: moment("02.10.2026 19:00", this.dateFormat + this.timeFormat),
                canceled: false
            }
        ])
    }
}

export default fakeAppointmentsService;